import { queryString } from '@shared/hooks/recoil-query';
import { api_ } from '@shared/plugIn/axios';
import { LowerRole, UserRole } from '@shared/types';

import {
  bugoAgencyWorkerUpdate,
  GuestInfo,
  User,
  UserCreate,
  UserUpdate,
} from './user.interface';

export const nonAdminUpdateUser = async (userUpdate: bugoAgencyWorkerUpdate) => {
  const { data: user } = await api_.patch(`auth/me/detail`, userUpdate);
  return user;
};

export const createOrGetStoreGuest = async (guestInfo: GuestInfo, role: LowerRole) => {
  const { data: user } = await api_.post<User>(
    `${role}/user/create-or-get/store-guest`,
    guestInfo,
  );
  return user;
};

export const adminCreateUser = async (userCreate: UserCreate) => {
  const { data: user } = await api_.post<User>('admin/user', userCreate);
  return user;
};

export const adminUpdateUser = async (userUpate: UserUpdate) => {
  const { data: user } = await api_.patch<User>(`admin/user/${userUpate._id}`, userUpate);
  return user;
};

export const agencyAdminUpdateWorker = async (userUpate: UserUpdate) => {
  const { data: user } = await api_.patch<User>(
    `bugo-agency-admin/user/${userUpate._id}`,
    userUpate,
  );
  return user;
};

export const agencyAdminCreateWorker = async (userCreate: UserCreate) => {
  const { data: user } = await api_.post<User>(`bugo-agency-admin/user`, userCreate);
  return user;
};

export const adminUserListByRoles = async (roles: UserRole[]) => {
  const { data } = await api_.get<User[]>(
    `admin/user/?${queryString({
      filter: { roles: { $in: roles } },
    })}`,
  );
  return data;
};

//* GiftBrandSeller(답례품 배송관리자) 목록 - 담당 브랜드 populate
export const adminGiftBrandSellerList = async () => {
  const { data } = await api_.get<User[]>(
    `admin/user/?${queryString({
      filter: { roles: UserRole.GiftBrandSeller },
      populate: { path: 'giftItemBrand', select: 'name' },
      options: { sort: { createdAt: -1 } },
    })}`,
  );
  return data;
};

//* GiftBrandSeller 계정 생성 (담당 브랜드 지정)
export interface GiftBrandSellerCreate {
  username: string;
  password: string;
  name: string;
  phoneNumber: string;
  giftItemBrand: string;
}

export const adminCreateGiftBrandSeller = async (dto: GiftBrandSellerCreate) => {
  const { data: user } = await api_.post<User>('admin/user', {
    username: dto.username,
    password: dto.password,
    roles: [UserRole.GiftBrandSeller],
    giftItemBrand: dto.giftItemBrand,
    info: {
      name: dto.name,
      gender: '',
      birth: '',
      phoneNumber: dto.phoneNumber,
    },
  });
  return user;
};

export const adminAgencyWorkerWelcomeSend = async (userId: string) => {
  const { data } = await api_.get(`admin/alert/agency-worker-welcome/${userId}`);
  return data;
};
